/*
 * @Author: Teemo Ding
 * @Date: 2021-09-14 17:21:56
 * @LastEditTime: 2022-06-10 14:21:37
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelDomain/List/config.tsx
 */
import {
  Form, //CompositionInput as Input
} from '@/src/components/Antd';

import React from 'react';
import css from './css.module.less';
import { TableInput } from 'src/components/EditableTable/TableForm1';

const { Item } = Form;
import Actions from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import { EnumTablePosition } from 'src/types/common/common';
import { EditIcon } from '@/src/components/EditableTable/EditableTable';
export const redirectColumns = ({ fields, remove, form, onCheck, getI18n }) =>
  // linkListData,
  [
    {
      title: (
        <span>
          <span style={{ marginRight: 12 }}>
            {getI18n('salesChannelDigitalMarketing.index.metaTag')}
          </span>

          <EditIcon />
          {/* <Tip
            title='Redirect URL allowed characters'
            // extra={
            //   <React.Fragment>
            //     <br /> Slash (/)
            //   </React.Fragment>
            // }
          /> */}
        </span>
      ),
      dataIndex: 'MetaTag',
      key: 'MetaTag',
      default: true,
      optional: false,
      className: css.columnClass,
      minWidth: 900,
      childGenerate: (text, record, index) => {
        return (
          // <Item shouldUpdate>
          //   {({ getFieldValue }) => {
          //     // form.validateFields('customRedirections').then((re) => {
          //     //   console.log('re', re);
          //     // });
          //     return (
          <Item
            style={{ width: '100%' }}
            rules={[
              {
                required: true,
                message: getI18n(
                  'salesChannelDigitalMarketing.index.fieldRequired',
                ),
              },
              { validator: onCheck },
              // {
              //   validator: async (x, value) => {
              //     if (value) {
              //       const isGoodStart = urlStartWith.test(value);
              //       if (!isGoodStart) {
              //         return Promise.reject(new Error(`Don't start with / `));
              //       }
              //     }
              //   },
              // },
              // {
            ]}
            className={css.missingPageType}
            name={[fields[index].name, 'metaTag']}>
            <FormInput fields={fields} form={form} index={index} />
          </Item>
          //     );
          //   }}
          // </Item>
        );
      },
    },

    {
      title: getI18n(
        'general.advancedFilters.commonStoreProductsWithTable.actions',
      ),
      dataIndex: 'action',
      key: 'action',
      default: true,
      optional: false,
      width: 256,
      position: EnumTablePosition.mid,
      align: 'center',
      childGenerate: (text, record, index) => {
        return (
          <Actions
            onDelete={() => {
              remove(index);
              setTimeout(() => {
                form.validateFields([['metaTagList', index, 'metaTag']]);
              }, 500);
              // const total = fields.length;
              // const list = [];
              // for (let i = 0; i < total; i++) {
              //   const name = _name(i);
              //   const isTouch = form.isFieldTouched(name);
              //   // const targetValue = form.getFieldValue(name);
              //   if (
              //     isTouch //|| targetValue
              //   ) {
              //     list.push(i);
              //   }
              // }
              // const validateNames = list.map((i) => {
              //   const name = _name(i);
              //   return name;
              // });
              // form.validateFields(validateNames);
            }}
            // disableDelete={!isEditing}
          />
        );
      },
    },
  ];

//const _name = (i) => ['customRedirections', i, 'url'];
// const recheckOtherParts = ({ fields, index, form }) => {
//   const total = fields.length;
//   const list = [];
//   for (let i = 0; i < total; i++) {
//     if (i !== index) {
//       const name = _name(i);
//       const isTouch = form.isFieldTouched(name);
//       // const targetValue = form.getFieldValue(name);
//       if (
//         isTouch //|| targetValue
//       ) {
//         list.push(i);
//       }
//     }
//   }
//   const validateNames = list.map((i) => {
//     const name = _name(i);
//     return name;
//   });

//   return validateNames;
// };

const FormInput = (props) => {
  const { value, onChange, form, index, ...rest } = props;
  const e = form.getFieldError(['metaTagList', index, 'metaTag']);
  const hasError = (e || []).length > 0;
  return (
    <div className={css.domainContainer}>
      <div className={css.inputPart}>
        <TableInput
          value={value}
          label={value}
          error={hasError}
          itemProps={{
            noErrorDisplay: true,
          }}
          //size='large'
          //customFilter={filter}
          onChange={onChange}
          {...rest}
        />
      </div>
    </div>
  );
};
